import React from 'react';
import cx from 'classnames';
import cs from './index.module.scss';

const CheckBtnIcon: React.FC<any> = ({ className, width = 16, height = 16, ...restProps }) => (
  <span className={cx(cs.container, className)} {...restProps}>
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fillRule="evenodd" clipRule="evenodd" d="M12 2H4C2.89543 2 2 2.89543 2 4V12C2 13.1046 2.89543 14 4 14H12C13.1046 14 14 13.1046 14 12V4C14 2.89543 13.1046 2 12 2ZM4 0C1.79086 0 0 1.79086 0 4V12C0 14.2091 1.79086 16 4 16H12C14.2091 16 16 14.2091 16 12V4C16 1.79086 14.2091 0 12 0H4Z" fill="#A0A0A0"/>
  </svg>
  </span>
);

export default CheckBtnIcon;
